module.exports = __webpack_public_path__ + "static/media/file-signature.4fc2e87d.svg";